import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';
import { useChatbotAssistant } from '../../provider/chatbot-assistant.provider';
import { getWeaveCopilotTrackingId, WEAVE_COPILOT_ACTIONS } from '../../tracking-ids';

export const PanelControls: FC<{ onPopoutAction?: () => void; onMinimizeAction?: () => void }> = ({
  onPopoutAction,
  onMinimizeAction,
}) => {
  const { t } = useTranslation('aiOnboarding');
  const { source } = useChatbotAssistant();
  return (
    <div css={styles.container}>
      <NakedButton
        onClick={onPopoutAction}
        aria-label={t('Pop Out')}
        css={styles.iconButton}
        trackingId={getWeaveCopilotTrackingId({ action: WEAVE_COPILOT_ACTIONS.popoutButton, source })}
      >
        <Icon name='pop-out-small' size={16} />
      </NakedButton>
      <NakedButton
        onClick={onMinimizeAction}
        aria-label={t('Minimize')}
        css={styles.iconButton}
        trackingId={getWeaveCopilotTrackingId({ action: WEAVE_COPILOT_ACTIONS.minimizeButton, source })}
      >
        <Icon name='minus-small' size={16} />
      </NakedButton>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(0.5)};
  `,
  iconButton: css`
    padding: ${theme.spacing(0.5)};
    svg {
      color: ${theme.colors.neutral70};
    }
  `,
};
